import type { DataTypeInfo } from "./types/api-types";

export const DATA_TYPES: DataTypeInfo[] = [
  { id: 1, description: "Variable length text", variableLength: true },
  { id: 2, description: "Text", variableLength: false },
  { id: 3, description: "Date", variableLength: false },
  { id: 4, description: "Date and Time", variableLength: true },
  { id: 5, description: "Integer", variableLength: false },
  { id: 6, description: "Monetary", variableLength: true },
];

export const INITIAL_FORM_DATA = {
  useDataValidator: true,
  minLength: 0,
  maxLength: 0,
  allowLetters: false,
  allowNumbers: false,
  allowSpaces: false,
  allowFutureDates: false,
  dataType: null,
  validCharactersList: [],
  validRegexList: [],
  replacementCharacters: [
    { value: "E", replacement: "-" },
    { value: "X", replacement: "-" },
    { value: "e", replacement: "-" },
  ],
  routines: ["[Cleaning] [usp_Cleanse_Phone_Number2]"],
  validValues: [],
};
